import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInvitationLink } from '../../../../../api';

export const adminUsersByIdLinksInvitationGetSlice = createGetAsyncSlice({
	name: 'AdminUsersByIdLinksInvitation',
	receive: true,
	request: true,
	requestHandler: getInvitationLink,
	retainDataOnRequest: false
});
